<template>
<div class="txt">

      <div v-show="accesible">
      
      <div class="w-100 p-2 text-light fijoArribaTop bg-success" > 
      <!--
          <b-form-checkbox autofocus="true" size="lg" v-model="accesible" name="check-button" switch @change="actualizarPagina(accesible)">
          <strong>Página ACCESIBLE</strong>
        </b-form-checkbox> -->


       <b-container>
        <b-row>
          <b-col cols="8">
             <b-form-checkbox autofocus="true" size="lg" v-model="accesible" name="check-button" switch @change="actualizarPagina(accesible)">
               <strong>Página ACCESIBLE</strong>
             </b-form-checkbox>
          
          </b-col>
          <b-col cols="4">
                <b-button variant="primary" block pill to="proyecto"  size="lg">Información del proyecto</b-button>
          </b-col>
        </b-row>
      </b-container>




      </div>
      </div>

    <div v-show="!accesible">
      <div class="w-100 p-2 text-light fijoArribaTop bg-danger">
       
       <b-container>
        <b-row>
          <b-col cols="8">
             <b-form-checkbox autofocus="true" size="lg" v-model="accesible" name="check-button" switch @change="actualizarPagina(accesible)">
               <strong>Página <strong>NO </strong> ACCESIBLE</strong>
             </b-form-checkbox>
          
          </b-col>
          <b-col cols="4">
               <b-button variant="primary" block pill to="proyecto" class="">Información del proyecto</b-button>
          </b-col>
        </b-row>
      </b-container>
      <!--
        <b-form-checkbox autofocus="true" size="lg" v-model="accesible" name="check-button" switch @change="actualizarPagina(accesible)">
          <strong>Página <strong>NO </strong> ACCESIBLE</strong>
               <b-button variant="primary" href="proyecto" class="">Información del proyecto</b-button>
          </b-form-checkbox>
          -->
      </div>
      </div>
  



<!--
    <b-button-group>
      <b-button @click="()=>$router.push('HomeA')" size="lg" variant="success">Mostrar web accesible</b-button>
      <b-button @click="()=>$router.push('HomeNA')"  size="lg" variant="danger">Mostrar web no accesible</b-button>
    </b-button-group>
-->
      



<b-row>

  </b-row>
  <!-- <b-navbar toggleable="md" type="dark" class="w-100 p-3 fijoArriba50"> -->
  <b-navbar toggleable="md" type="light" variant="light" class="w-100 p-3 fijoArriba50">
      <!-- <b-navbar-brand to="/HomeNA"> -->
      
      
 
      <span v-show="accesible">
        <b-navbar-brand>
          <img src="../assets/img/iconoCongreso.png" height="60" width="180" alt="Pagina de inicio del congreso interaccion" to="/">
        </b-navbar-brand>
      </span>

      <span v-show="!accesible">
        <b-navbar-brand>
          <img src="../assets/img/iconoCongreso.png" height="60" width="180" alt="icono" to="/">
        </b-navbar-brand>
      </span>
      

    <b-navbar-toggle target="nav-coll"></b-navbar-toggle>
      <b-container>
        <b-collapse id="nav-coll" is-nav>
          
              <span v-show="accesible">
              <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
              
                <b-navbar-nav class="textoGrande" >

                <b-nav-item href="HomeA#presentacion" class="nav-link">Presentacion</b-nav-item>
                <b-nav-item  href="HomeA#sede" class="nav-link">Sede</b-nav-item>
                <b-nav-item  href="HomeA#contacto" class="nav-link">Contacto</b-nav-item>
                <!--<b-nav-item class="nav-link" href="proyecto" >Sobre el proyecto</b-nav-item> -->

                </b-navbar-nav>
              </ul>

              </span>
              <span v-show="!accesible">
              
              <ul class="navbar-navss ms-auto mb-2 mb-lg-0">
               

                <b-navbar-nav class="nav-linkss">
                <!-- tiene una clase que no se marcara en negro cuando el elemento este seleccionado-->
                <b-nav-item href="HomeNA#presentacion" class="nav-linkss">Presentacion</b-nav-item>
                <b-nav-item href="HomeNA#sede" class="nav-linkss">Sede</b-nav-item>
                <b-nav-item href="HomeNA#contacto" class="nav-linkss">Contacto</b-nav-item>
                <!-- <b-nav-item class="nav-linkss" to="proyecto" >Sobre el proyecto</b-nav-item> -->
                <!-- <b-nav-item href="HomeNA#contacto" class="nav-linkss">Contacto</b-nav-item> -->


                </b-navbar-nav>
              </ul>

              </span>

              <!-- <b-nav-item to="/HomeA" @click="scrollInto('presentacion')">Presentación</b-nav-item>
              <b-nav-item to="/HomeA" @click="scrollInto('sede')">Sede</b-nav-item>
              -->
              
        </b-collapse>

      </b-container>
  </b-navbar>
  <!--
  <div v-show="!accesible">
    <div class="w-100 p-5 text-light fijoArribaTop"> 
      <Modal :identificador="0"/>
    </div>
    </div>
    -->
  </div>

</template>

<script>

//import Modal from './Modal.vue'


export default {
  name: 'Menu',
  data() {
      return {
        accesible: false,
      }
    },
  //components: { Modal },
  methods:{

    actualizarPagina: function (accesible) {

      if (accesible) {
        this.$router.push('HomeA')
      }
      else {
        //alert(event.target.tagName)
        this.$router.push('HomeNA')
      }
    }
  }
}
</script>

<style>
.txt{
  text-align: center;
}
.medidaTxtG {
    text-align: center;
    font-size: 1.8em;
}
.fijoArriba50{
position: -webkit-sticky;
position:fixed;
top:45px;
z-index: 1030;
background-color: whitesmoke;
}
.fijoArribaTop{
position: -webkit-sticky;
position:fixed;
top:0;
height: 2.9em;
z-index: 1030;
}

.navbar-dark .navbar-nav .nav-link {
    color: black;
}

.navbar-dark .navbar-nav .nav-link:focus, .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:active {
    background-color: rgb(0, 0, 0);
    color:white;

}
.navbar-dark .navbar-nav .nav-linkss:hover, .navbar-dark .navbar-nav .nav-linkss:active, .navbar-dark .navbar-nav .nav-linkss:focus {

      background-color: white !important;
}
/*
.nav-link:active{
 .router-link-exact-active, .router-link-active 
  background-color: rgb(0, 0, 0);
  color:white;

}
*/

.textoGrande {
  font-size: 1.5em;
}
</style>





